import { PropsWithChildren } from 'react';
import { tv } from 'tailwind-variants';

const style = tv({
  base: `
    flex
    flex-col
    gap-s
  `
});

type Props = PropsWithChildren;

export const PriceCardContainer = ({ children }: Props) => {
  return <div className={style()}>{children}</div>;
};
